import * as React from "react";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { subAccountTypeMap } from "../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Performance/Resource/Contents";
import { SubAccountTypeHelper } from "../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { IsaFolderIcon } from "./IsaFolderIcon";
import { OffshoreBondFolderIcon } from "./OffshoreBondFolderIcon";
import { OnshoreBondFolderIcon } from "./OnshoreBondFolerIcon";
import { PPFolderIcon } from "./PPFolderIcon";
import { SIPPFolderIcon } from "./SippFolderIcon";
import { JSIPPFolderIcon } from "./JSIPPFolderIcon";
import { WcFolderIcon } from "./WcFolderIcon";

interface ITransitionProps {
    from: SubAccountType;
    to: SubAccountType;
}

export const Transition = (props: ITransitionProps) => {
    const { from, to } = props;

    const getIcon = (type: SubAccountType, isComplete: boolean): JSX.Element => {
        if (SubAccountTypeHelper.isOnPlatformPension(type) || SubAccountTypeHelper.isOffPlatformPension(type)) {
            return <SIPPFolderIcon isCompleted={isComplete} />;
        }
        if (SubAccountTypeHelper.isIsa(type)) {
            return <IsaFolderIcon isCompleted={isComplete} />;
        }
        if (SubAccountTypeHelper.isPP(type)) {
            return <PPFolderIcon isCompleted={isComplete} />;
        }
        if (type == SubAccountType.JuniorSipp) {
            return <JSIPPFolderIcon isCompleted={isComplete} />;
        }
        if (SubAccountTypeHelper.isWrapCash(type)) {
            return <WcFolderIcon isCompleted={isComplete} />;
        }
        if (type == SubAccountType.OnshoreBond) {
            return <OnshoreBondFolderIcon isCompleted={isComplete} />;
        }
        if (type == SubAccountType.OffshoreBond) {
            return <OffshoreBondFolderIcon isCompleted={isComplete} />;
        }

        return null;
    };

    return (
        <>
            <h2 style={{ textAlign: "center" }}>{subAccountTypeMap[from]} details complete</h2>
            <p style={{ textAlign: "center" }} className="mb-20">
                Next: {subAccountTypeMap[to]}
            </p>
            <div className="product-diagram-container">
                <div className="row">
                    <div className="col-4 col-center col-auto">
                        <div className="product-item">
                            {getIcon(from, true)}
                            <p className="produckt-text">{subAccountTypeMap[from]}</p>
                        </div>
                    </div>

                    <div className="col-4 col-center col-auto col-middle">
                        <span className="transition-arrow"></span>
                    </div>
                    <div className="col-4 col-center col-auto">
                        <div className="product-item">
                            {getIcon(to, false)}
                            <p className="produckt-text">{subAccountTypeMap[to]}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
